import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

const findProfiles = createAsyncThunk(
  "profilesList/find",
  async (filter, { getState, rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}profile`);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export default findProfiles;
